import addressHelper from '@/mixins/address-helper'
import { serviceTypes } from '@/store/api/order'
import moment from 'moment'
import * as constants from '../../mixins/constants'
import * as types from '../mutation-types'
const { pick, sumBy } = require('@/plugins/lodash')

import { filter } from '@/plugins/lodash'

import {
  // create,
  createRental,
  // estimatedFeeV2,
  // estimatedFee,
  estimatedFeeRental,
  getFeaturedBanner,
  getOrderListByToken,
  getPromoList
} from '@/store/api/order'

import { getCookie, getMaxStopPointByService, setCookie, setItemStorage } from '@/plugins/util'

import {
  // legacy_getOrderRequestParams,
  // estimateFeeV2Middleware,
  estimateFeeV3Middleware,
  getOrderRequestParamsByService,
  prepareInsuranceRequest
  // sendTrackingLinkViaPageInbox
} from '@/utils/order'

import {
  COOKIE_EXPIRES_MAX_AGE__3M,
  COOKIE_NAME__PICKUP_LOCATION,
  COOKIE_NAME__SELECTED_SERVICE_ID,
  CREATE_ORDER_ERROR_TEMPLATE,
  CURRENCY_CONFIG,
  CURRENCY_SYMBOL,
  DELIVERY_TYPE,
  ERROR_CODES,
  LOCAL_STORAGE_KEY__LATEST_PAYMENT_METHOD,
  PAYMENT_METHODS
} from '@/mixins/constants'
// CURRENCY_SYMBOL,
// import { estimateFeeParamsCreator } from '@/plugins/util'

import * as nationwideOrderForm from '../modules/nationwide-order-form'
import * as rentalForm from '../modules/rental'
import * as truckOrderForm from '../modules/truck-order-form'

import i18n from '@/plugins/i18next.js'

import OrderFormWorker from '@/utils/workers/web-workers/order-form.worker.js'
import * as Comlink from 'comlink'
import { useCreateOrderV3, useEstimateFeeV3 } from '../../utils/order'
// const orderFormWorker = new OrderFormWorker();
// const { sendMessageToFacebookConversation } = Comlink.wrap(orderFormWorker);

const state = {
  path: [],
  setPathLogTime: null,
  service: {},
  requests: [],
  remarks: '',
  orderTime: 0,
  setOrderTimeForPickup: false,
  images: [],
  promoCode: '',
  payment_method: PAYMENT_METHODS.CASH,
  pod_payment_methods_list: [],
  estimateFeeTimeout: null,
  estimatedFee: {},
  estimatingFee: false,
  estimateFeeError: null,

  estimateFeeAllServicesTimeout: null,
  estimatedFeeAllServices: [],
  estimatingFeeAllServices: false,
  estimateFeeAllServicesError: null,
  shouldEstimateFeeAllServices: true,

  creatingOrder: false,
  createOrderError: null,
  lastCreateOrderParams: null,

  isShowedAddBankModal: false,
  isAutoRedeemedPromoCode: false,

  promotionList: [],
  featuredBanner: null,
  method_picked: {},

  insuranceService: {
    isEnable: true,
    insuranceValue: constants.INSURANCE_PACKAGE_TYPE.BASIC
  },

  initLocation: {},
  ...nationwideOrderForm.default.state,
  ...truckOrderForm.default.state,
  ...rentalForm.default.state,
  activeEntryPoint: null // 'select_vehicle' | 'place_order' | 'confirm_order'
}

// getters
const getters = {
  initLocation: (state) => state.initLocation,
  orderFormData: (state) => {
    return {
      path: state.path,
      service: state.service,
      requests: state.requests,
      remarks: state.remarks,
      order_time: state.orderTime,
      images: state.images,
      promo_code: state.promoCode,
      payment_method: state.payment_method,
      distance: state.estimatedFee && state.estimatedFee.distance
    }
  },
  orderFormRental: (state) => {
    return {
      idle_until: state.orderTime,
      order_time: state.orderTime,
      path: state.path,
      service_id: state.service._id,
      requests: state.requests,
      number_of_drivers: state.number_of_drivers,
      hours_of_rental: state.hours_of_rental,
      booking_description: state.booking_description,
      payment_method: state.payment_method,
      promo_code: state.promoCode,
      total_pay: state.estimatedFee.total_pay
    }
  },
  orderParamsTriggerEstimateFee: (state) => {
    return {
      path: state.path,
      // Note: select service will auto get estimatedFee payload which estimated on all service list
      // service: state.service,
      requests: state.requests,
      promo_code: state.promoCode,
      payment_method: state.payment_method,
      order_time: state.orderTime
    }
  },
  orderParamsTriggerEstimateFeeRental: (state) => {
    return {
      service_id: state.service._id,
      path: state.path,
      requests: state.requests,
      promo_code: state.promoCode,
      payment_method: state.payment_method,
      order_time: state.orderTime,
      number_of_drivers: state.number_of_drivers,
      hours_of_rental: state.hours_of_rental
    }
  },
  orderFormDataV2: (state) => {
    return {
      path: state.path,
      service: state.service,
      requests: state.requests,
      order_time: state.orderTime,
      images: state.images,
      promo_code: state.promoCode,
      payment_method: state.payment_method
    }
  },
  orderFormPath: (state) => state.path,
  orderFormService: (state) => state.service,
  orderFormIsFlashSaleService: (state) => {
    return state.service && state.service._id && !state.service.require_to
  },
  orderFormRequests: (state) => state.requests,
  orderFormRemarks: (state) => state.remarks,
  orderFormOrderTime: (state) => state.orderTime,
  orderFormImages: (state) => state.images,
  orderFormPromoCode: (state) => state.promoCode,
  orderFormPaymentMethod: (state) => state.payment_method,
  podPaymentMethodList: (state) => state.pod_payment_methods_list,
  orderFormEstimateFeeTimeout: (state) => state.estimateFeeTimeout,
  orderFormEstimatedFee: (state) => {
    let result = state.estimatedFee
    if (result && result.total_price >= 0) {
      const currencySymbol = CURRENCY_SYMBOL[result.currency]
      Object.assign(result, {
        visible: true,
        currency_symbol: currencySymbol,
        formatted_label: result.total_price.toLocaleString('en-US', {
          style: 'currency',
          currency: 'VND'
        })
      })
    }
    return result
  },
  merchant: (state) => {
    // return if these is flash sale service
    return (
      state.service &&
      !state.service.require_to &&
      state.estimatedFee &&
      state.estimatedFee.merchant
    )
  },
  orderFormEstimatingFee: (state) => state.estimatingFee,
  orderFormEstimateFeeError: (state) => state.estimateFeeError,
  orderFormPathLogTime: (state) => state.setPathLogTime,
  orderFormCreatingOrder: (state) => state.creatingOrder,
  setOrderTimeForPickup: (state) => state.setOrderTimeForPickup,

  orderFormEstimatingFeeAllServices: (state) => state.estimatingFeeAllServices,
  estimatedFeeAllServices: (state) => state.estimatedFeeAllServices,

  orderFormSupportedPaymentMethods: (state) => state.service && state.service.payment_method,

  isValidOrderForm: (state, rootState) => {
    // NOTE: order of errors is important(service/path/cod/estimate/payment)

    let result = {}
    const service = state.service || {}

    // Check require service
    if (!service._id) {
      result.service = {
        invalid: true,
        msg: 'new_order.messages.required_service_type'
      }
    }

    // Check require min/max stoppoints
    const path = filter(state.path, (item) => {
      return !item.disabled && item.is_valid
    })
    const pathLength = path.length
    if (service.delivery_type !== DELIVERY_TYPE.TRUCK) {
      if (service.require_to) {
        const numOfStoppoint = pathLength - 1
        const userProfile = rootState.user && rootState.user.profile
        const maxStoppoint = getMaxStopPointByService(service, userProfile)
        const minStoppoint = service.min_stop_points || 1
        if (numOfStoppoint < minStoppoint) {
          result.path = {
            invalid: true,
            msg: {
              key: 'new_order.messages.required_min_stoppoints_v2',
              data: {
                service: service.name,
                n: minStoppoint
              }
            }
          }
        } else if (numOfStoppoint > maxStoppoint) {
          result.path = {
            invalid: true,
            warning: true,
            msg: {
              key: 'new_order.messages.required_max_stoppoints_v2',
              data: {
                service: service.name,
                n: maxStoppoint
              },
              color: 'red'
            }
          }
        }
      } else if (pathLength !== 1) {
        result.path = {
          invalid: true,
          msg: {
            key: 'new_order.messages.required_dropoff_for_flashsale'
          }
        }
      }
    }

    // Check valid cod
    // const maxCODPerStoppoint = service.max_cod_per_stop_point || service.cod
    const maxCODPerUser = rootState.userProfile && rootState.userProfile.max_cod
    const maxCODPerOrder = service.max_cod

    const sumOfCOD = sumBy(path, 'cod')
    if (maxCODPerOrder > 0 && sumOfCOD > maxCODPerOrder) {
      const currencyPrefix = CURRENCY_CONFIG && CURRENCY_CONFIG.prefix
      result.cod = {
        invalid: true,
        warning: true,
        msg: {
          key: 'new_order.messages.invalid_max_cod',
          data: {
            cod: `${currencyPrefix}${maxCODPerOrder.toLocaleString()}`
          },
          color: 'red'
        }
      }
    }

    path.some((p) => {
      if (!maxCODPerOrder && p.cod > 0) {
        result.cod = {
          invalid: true,
          warning: true,
          msg: {
            key: 'dropoff_address.not_supported_cod',
            color: 'red'
          }
        }
        return true
      } else if (maxCODPerUser > 0 && p.cod > maxCODPerUser) {
        const currencyPrefix = CURRENCY_CONFIG && CURRENCY_CONFIG.prefix
        result.cod = {
          invalid: true,
          warning: true,
          msg: {
            key: 'dropoff_address.form.invalid_cod_due_to_max_cod_per_user',
            data: {
              max_cod_per_stop_point: `${currencyPrefix}${maxCODPerUser.toLocaleString()}`
            },
            color: 'red'
          }
        }
        return true
      } else return false
    })

    // Check estimate fee error
    if (state.estimateFeeError) {
      let key = 'estimated_fee.estimate_fee_error'
      let error = ''
      let code = ''
      if (state.estimateFeeError.data && state.estimateFeeError.data.http_code) {
        // Check user is suspended
        if (`${state.estimateFeeError.data.http_code}`.includes(ERROR_CODES.SUSPENDED_USER.code)) {
          code = ERROR_CODES.SUSPENDED_USER.code
        }
        key = 'estimated_fee.estimate_fee_specify_error'
        error = state.estimateFeeError.data.description || state.estimateFeeError.data.title || ''

        switch (state.estimateFeeError.data.title) {
          case CREATE_ORDER_ERROR_TEMPLATE.DISTANCE_NOT_VALID:
            key = 'estimated_fee.estimate_fee_distance_error'
            error = ''
            break
          default:
        }
      }

      result.estimate = {
        code,
        invalid: true,
        msg: {
          key,
          data: {
            error
          },
          color: 'red'
        }
      }
    }

    // Check not enough credit
    if (
      state.estimatedFee &&
      state.estimatedFee.payment_error_message === CREATE_ORDER_ERROR_TEMPLATE.NOT_ENOUGH_CREDIT
    ) {
      result.payment = {
        invalid: true,
        msg: {
          key: 'payment_method.insufficient_balance.title'
        }
      }
    }

    // console.log('result...', result)
    return Object.keys(result).length === 0 ? true : result
  },
  methodPicked: (state) => state.method_picked,
  insuranceService: (state) => state.insuranceService,

  ...nationwideOrderForm.default.getters,
  ...truckOrderForm.default.getters,
  ...rentalForm.default.getters
}

// actions
const actions = {
  resetOrderForm({ commit }) {
    commit(types.RESET_ORDER_FORM)
    commit(types.RESET_TRUCK_FORM)
  },
  resetPath({ commit }) {
    commit(types.RESET_ORDER_PATH)
  },
  initOrderFormPath({ commit, dispatch }) {
    const cookieStr = getCookie(COOKIE_NAME__PICKUP_LOCATION)
    const cookieLocation = cookieStr && JSON.parse(cookieStr)
    if (cookieLocation && cookieLocation.lat && cookieLocation.lng) {
      let location = cookieLocation
      addressHelper.methods.checkIsValidAddress(location)

      // Check to update user cityId
      const params = {
        city_lat: location.lat,
        city_lng: location.lng
      }
      // Delay for loading page's resource
      setTimeout(() => {
        dispatch('updateUserRegion', params)
      }, 3000)

      commit(types.INIT_ORDER_FORM_PATH, location)
    }
  },
  initOrderFormPathFormLocation({ commit, dispatch }, data) {
    if (data && data.lat && data.lng) {
      let location = data
      addressHelper.methods.checkIsValidAddress(location)

      // Check to update user cityId
      const params = {
        city_lat: location.lat,
        city_lng: location.lng
      }
      // Delay for loading page's resource
      setTimeout(() => {
        dispatch('updateUserRegion', params)
      }, 3000)

      commit(types.INIT_ORDER_FORM_PATH, location)
    }
  },
  setOrderFormPath({ commit, dispatch, rootGetters }, data) {
    const pickedField = [
      'lat',
      'lng',
      'address',
      'name',
      'mobile',
      'remarks',
      'apt_number',
      'building',
      'short_address',
      'first_label',
      'second_label',
      'types',
      'adr_source',
      'fb_conversation_id',
      'item_value',
      'level'
    ]
    const pickupLocation = {
      old: (state.path && state.path[0] && pick(state.path[0], pickedField)) || {},
      new: data && data[0] && pick(data[0], pickedField)
    }
    // eslint-disable-next-line prettier/prettier
    const isChangedPickupLocation =
      pickupLocation.new &&
      Object.entries(pickupLocation.old).toString() !==
        Object.entries(pickupLocation.new).toString()

    const checkValidMethodName =
      rootGetters && rootGetters.isSelectedNationwideService
        ? '$addressHelper_isValidNationwideAddress'
        : 'checkIsValidAddress'

    data.forEach((point, index) => {
      addressHelper.methods[checkValidMethodName](point, index)
    })

    if (isChangedPickupLocation) {
      setCookie(
        COOKIE_NAME__PICKUP_LOCATION,
        JSON.stringify(pickupLocation.new),
        COOKIE_EXPIRES_MAX_AGE__3M
      )
    }

    // Check to update user cityId
    if (data[0] && data[0].lat && data[0].lng) {
      const params = {
        city_lat: data[0].lat,
        city_lng: data[0].lng
      }
      dispatch('updateUserRegion', params)
    }

    commit(types.SET_ORDER_FORM_PATH, data)
  },
  setOrderFormService({ commit }, data) {
    commit(types.SET_ORDER_FORM_SERVICE, data)
  },
  addOrderFormRequests({ commit }, requests) {
    commit(types.ADD_ORDER_FORM_REQUESTS, requests)
  },
  removeOrderFormRequests({ commit }, requests) {
    commit(types.REMOVE_ORDER_FORM_REQUESTS, requests)
  },
  setOrderFormEstimatedFee({ commit }, data) {
    commit(types.SET_ORDER_FORM_ESTIMATED_FEE, data)
  },
  setOrderFormEstimateFeeTimeout({ commit }, data) {
    commit(types.SET_ORDER_FORM_ESTIMATE_FEE_TIMEOUT, data)
  },
  setOrderFormEstimatingFee({ commit }, data) {
    commit(types.SET_ORDER_FORM_ESTIMATING_FEE, data)
  },
  setOrderFormEstimateFeeError({ commit }, data) {
    commit(types.SET_ORDER_FORM_ESTIMATE_FEE_ERROR, data)
  },
  setOrderFormCreatingOrder({ commit }, data) {
    commit(types.SET_ORDER_FORM_CREATING_ORDER, data)
  },
  setOrderFormOrderTime({ commit }, data) {
    commit(types.SET_ORDER_FORM_ORDER_TIME, data)
  },
  setOrderFormPromoCode({ commit }, code) {
    commit(types.SET_ORDER_FORM_PROMO_CODE, code)
  },
  setOrderFormRemarks({ commit }, remarks) {
    commit(types.SET_ORDER_FORM_REMARKS, remarks)
  },
  setOrderFormImages({ commit }, images) {
    commit(types.SET_ORDER_FORM_IMAGES, images)
  },
  setOrderFormAllInfo({ commit }, formData) {
    commit(types.SET_ORDER_FORM_ALL_INFO, formData)
  },
  setOrderPaymentMethod({ commit }, method) {
    commit(types.SET_ORDER_FORM_PAYMENT_METHOD, method)
  },
  setPODPaymentMethodsList({ commit }, data) {
    commit(types.SET_POD_PAYMENT_METHODS_LIST, data)
  },
  resetOrdersEstimatedFee({ commit }) {
    commit(types.RESET_ORDER_FORM_ESTIMATE_FEE)
  },
  getEstimatedFeeCustomPath({ rootGetters }, customPath) {
    return new Promise((resolve, reject) => {
      const serviceId = state.service && state.service._id
      const isPartner = Boolean(
        rootGetters && rootGetters.partnerGetFromToken && rootGetters.partnerGetFromToken.isPartner
      )

      if (!serviceId) {
        reject('no service')
      }

      let params = getOrderRequestParamsByService(state, state.service, {
        userProfile: rootGetters.userProfile,
        forEstimateFee: true,
        usePaymentMethodCash: true
      })

      // Set custom path
      params.path = customPath

      // Prepare params for estimatedFeeV3 api
      params.services = [
        {
          _id: serviceId,
          requests: params.requests
        }
      ]

      delete params.service_id
      delete params.requests
      // Endprepare params for estimatedFeeV3 api

      estimateFeeV3Middleware({
        targetDataId: serviceId
      })(useEstimateFeeV3(isPartner, params))
        .then((data) => {
          if (data) {
            resolve(data)
          } else {
            reject()
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getEstimatedFeeForSameParentServices({ commit, rootGetters, rootState }, config = {}) {
    return new Promise((resolve, reject) => {
      const service = state.service
      const serviceList = rootState.serviceTypes.service_types
      const isPartner = Boolean(
        rootGetters && rootGetters.partnerGetFromToken && rootGetters.partnerGetFromToken.isPartner
      )

      if (!service || !service._id) {
        reject('Missing selected service')
      }

      if (!service.parent_id) {
        reject('Selected service has no parent_id')
      }

      let params = getOrderRequestParamsByService(state, service, {
        userProfile: rootGetters.userProfile,
        forEstimateFee: true,
        usePaymentMethodCash: config.usePaymentMethodCash
      })
      params.services = [
        {
          _id: service._id,
          requests: params.requests
        }
      ]

      let sameParentServices = [service]
      serviceList.forEach((item) => {
        if (item._id !== service._id && item.parent_id === service.parent_id && item._id !== '') {
          params.services.push({
            _id: item._id,
            requests: []
          })
          sameParentServices.push(item)
        }
      })

      delete params.service_id
      delete params.requests

      commit(types.UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES, true)

      estimateFeeV3Middleware()(useEstimateFeeV3(isPartner, params))
        .then((data) => {
          if (!data || data.length < 2) {
            reject('Failure to estimate fee')
          }

          sameParentServices.forEach((service) => {
            data.forEach((value) => {
              if (value._id === service._id) {
                service.estimated_fee = value
              }
            })
          })

          resolve(sameParentServices)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getOrderFormEstimatedFee({ dispatch, commit, rootGetters }, config = {}) {
    return new Promise((resolve, reject) => {
      const serviceId =
        (state && state.service && state.service._id) ||
        (rootGetters && rootGetters.services[0] && rootGetters.services[0]._id)

      const isPartner = Boolean(
        rootGetters && rootGetters.partnerGetFromToken && rootGetters.partnerGetFromToken.isPartner
      )

      if (!serviceId) {
        reject('no service')
      }

      let params = getOrderRequestParamsByService(state, state.service, {
        userProfile: rootGetters.userProfile,
        forEstimateFee: true,
        usePaymentMethodCash: config.usePaymentMethodCash
      })

      // Add param to make estimate fee with suggested promotion
      if (config.autoRedeemPromoCode) {
        if (!state.promoCode) {
          params.suggest_promotion = true
        }
        dispatch('updateStatusAutoRedeemedPromoCode', true)
      }

      const insuranceRequests = prepareInsuranceRequest(state)
      if (insuranceRequests && insuranceRequests.length > 0) {
        params.requests = [...params.requests, ...insuranceRequests]
      }

      // Prepare params for estimatedFeeV3 api
      params.services = [
        {
          _id: serviceId,
          requests: params.requests
        }
      ]

      if (window && window.z_web_in_app_token) params.token = window.z_web_in_app_token

      delete params.service_id
      delete params.requests
      // Endprepare params for estimatedFeeV3 api

      commit(types.ESTIMATE_FEE_REQUEST)
      commit(types.UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES, true)

      estimateFeeV3Middleware({
        targetDataId: serviceId
      })(useEstimateFeeV3(isPartner, params))
        .then((data) => {
          if (data) {
            commit(types.ESTIMATE_FEE_SUCCESS, data)

            if (data.suggested_promotion) {
              dispatch('updateStatusAutoRedeemedPromoCode', data.suggested_promotion)
              dispatch('setOrderFormPromoCode', data.suggested_promotion)
            }

            resolve(data)
          } else {
            commit(types.ESTIMATE_FEE_FAILURE)
            reject('No response data')
          }
        })
        .catch((error) => {
          // If booking truck step 0 don't show message error and enable OrderPath
          if (config.bookingStep === 0) {
            state.estimatingFee = false
            return
          }
          commit(types.ESTIMATE_FEE_FAILURE, error)
          reject(error)
        })
    })
  },
  getOrderFormEstimatedFeeAllServices({ commit, rootState, rootGetters }) {
    var params = {}
    var _services = []
    const isPartner = Boolean(
      rootGetters && rootGetters.partnerGetFromToken && rootGetters.partnerGetFromToken.isPartner
    )

    const services = rootState.serviceTypes.service_types
    services.forEach((service) => {
      const pr = getOrderRequestParamsByService(state, service, {
        userProfile: rootGetters.userProfile,
        forEstimateFee: true,
        usePaymentMethodCash: true
      })

      // Estimate fee all services not support nationwide
      // TODO support nationwide
      if (!pr.invalid && service.delivery_type !== DELIVERY_TYPE.NATIONWIDE) {
        _services.push({
          _id: service._id,
          requests: pr.requests
        })
      }

      // if (service._id === state.service._id) {
      params = pr
      // }
    })

    if (_services.length > 0) {
      delete params.service_id
      delete params.requests

      params.services = _services

      commit(types.SET_ORDER_FORM_ESTIMATED_FEE_ALL_SERVICES, {
        data: [],
        error: null
      })
      state.estimatingFeeAllServices = true

      commit(types.UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES, false)
      estimateFeeV3Middleware()(useEstimateFeeV3(isPartner, params))
        .then((data) => {
          commit(types.SET_ORDER_FORM_ESTIMATED_FEE_ALL_SERVICES, {
            data
          })
        })
        .catch((error) => {
          commit(types.SET_ORDER_FORM_ESTIMATED_FEE_ALL_SERVICES, {
            error
          })
        })
    }
  },
  createOrder({ commit, dispatch, state, rootGetters }) {
    return new Promise((resolve, reject) => {
      // const params = legacy_getOrderRequestParams(state, rootGetters.kaProfile);
      const params = getOrderRequestParamsByService(state, state.service, {
        userProfile: rootGetters.userProfile,
        estimatedFee: state.estimatedFee,
        shouldStringifyObject: false,
        podPaymentMethodList: state.pod_payment_methods_list
      })
      const isPartner = Boolean(
        rootGetters && rootGetters.partnerGetFromToken && rootGetters.partnerGetFromToken.isPartner
      )

      if (params.payment_method) {
        setItemStorage(LOCAL_STORAGE_KEY__LATEST_PAYMENT_METHOD, params.payment_method)
      }

      const insuranceRequests = prepareInsuranceRequest(state)

      if (insuranceRequests && insuranceRequests.length > 0) {
        params.requests = [...params.requests, ...insuranceRequests]
      }

      commit(types.CREATE_ORDER_REQUEST)
      state.lastCreateOrderParams = params

      useCreateOrderV3(isPartner, params)
        .then((response) => {
          if (response) {
            // console.log('params', params);
            dispatch('updateStatusShowedAddBankModal', false)
            dispatch('updateStatusAutoRedeemedPromoCode', false)
            dispatch('updateLastUsedPlaces', state.path)

            resolve(response)

            // reset data use to create order
            dispatch('resetOrderForm')
            // reset orders list data cache in records
            dispatch('resetOrders')

            // send tracking link via page inbox
            const pageList = rootGetters.pageList
            const MinETA = Math.ceil(response.data.order.duration / 60)
            const MaxETA = Math.ceil(response.data.order.duration / 60 + 15)
            const message = i18n.t('message_eta_template', {
              order_id: response.data.order_id,
              shared_link: response.data.shared_link,
              min_eta: MinETA,
              max_eta: MaxETA
            })
            const orderFormWorker = Comlink.wrap(new OrderFormWorker())
            orderFormWorker.sendMessageToFacebookConversation(
              message,
              response.data.order,
              pageList
            )
          } else {
            reject('No response data')
          }
        })
        .catch((e) => {
          const error = (e && e.response) || (e && e.error) || null

          commit(types.CREATE_ORDER_FAILURE)
          return reject(error)
        })
    })
  },
  createRentalOrder({ commit, dispatch, state, rootGetters }) {
    return new Promise((resolve, reject) => {
      const params = {
        order_type: constants.ORDER_TYPE.RENT,
        ...rootGetters.orderFormRental
      }

      if (params.payment_method) {
        setItemStorage(LOCAL_STORAGE_KEY__LATEST_PAYMENT_METHOD, params.payment_method)
      }

      commit(types.CREATE_ORDER_REQUEST)
      state.lastCreateOrderParams = params
      createRental(params)
        .then((response) => {
          if (response) {
            // console.log('params', params);
            dispatch('updateStatusShowedAddBankModal', false)
            dispatch('updateStatusAutoRedeemedPromoCode', false)
            dispatch('updateLastUsedPlaces', state.path)

            resolve(response)

            // reset data use to create order
            dispatch('resetOrderForm')
            // reset orders list data cache in records
            dispatch('resetOrders')

            // send tracking link via page inbox
            const pageList = rootGetters.pageList
            const MinETA = Math.ceil(response.order.duration / 60)
            const MaxETA = Math.ceil(response.order.duration / 60 + 15)
            const message = i18n.t('message_eta_template', {
              order_id: response.order_id,
              shared_link: response.shared_link,
              min_eta: MinETA,
              max_eta: MaxETA
            })
            const orderFormWorker = Comlink.wrap(new OrderFormWorker())
            orderFormWorker.sendMessageToFacebookConversation(message, response.order, pageList)
          } else {
            reject('No response data')
          }
        })
        .catch((e) => {
          commit(types.CREATE_ORDER_FAILURE)
          reject(e || null)
        })
    })
  },

  getPromotionList({ commit, rootGetters }, params) {
    return new Promise((resolve, reject) => {
      getPromoList(params)
        .then((res) => {
          let data = []
          if (res && res.length > 0) {
            const locale = rootGetters.localeSuffix
            res.forEach((item) => {
              if (item._id) {
                item.desc = item['description' + locale] || item.description || item._id
                item.content = item['content' + locale] || item.content_en_us
                item.end_time_formatted = moment.unix(item.end_time).format('DD/MM/YYYY HH:mm')

                data.push(item)
              }
            })
          }
          commit(types.SET_PROMOTION_LIST, data)
          resolve()
        })
        .catch((e) => {
          console.error(e)
          reject()
        })
    })
  },
  loadFeaturedBanner({ commit, rootGetters }) {
    getFeaturedBanner()
      .then((res) => {
        if (res && res.length > 0) {
          let banner

          res.some((item) => {
            if (item.enable) {
              return (banner = item)
            }

            return false
          })

          if (banner) {
            const locale = rootGetters.localeSuffix

            commit(types.SET_FEATURED_BANNER, {
              ...banner,
              title: banner['title' + locale] || banner.title_en_us,
              description: banner['description' + locale] || banner.description_en_us,
              button: banner['button' + locale] || banner.button_en_us
            })
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  },
  updateShouldEstimateFeeAllServices({ commit }, value) {
    commit(types.UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES, value)
  },
  updateStatusShowedAddBankModal({ commit }, value) {
    commit(types.UPDATE_STATUS_SHOWED_ADD_BANK_MODAL, value)
  },
  updateStatusAutoRedeemedPromoCode({ commit }, value) {
    commit(types.UPDATE_STATUS_AUTO_REDEEMED_PROMO_CODE, value)
  },

  /* eslint-disable */
  getLastestOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      getOrderListByToken(params)
        .then((response) => {
          if (response) {
            resolve(response.data)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  async addDraftOrder({ commit, rootGetters }, params) {
    if (!params.payment_method) {
      params.payment_method = PAYMENT_METHODS.CASH
    }
    if (!params.requests) {
      params.requests = []
    }
    params.path.forEach((item) => {
      if (item.lng && item.lat) {
        item.is_valid = true
      }
    })

    let listService = rootGetters.serviceTypes

    if (listService.length === 0) {
      listService = await serviceTypes({ ...params.path[0] })
    }
    if (listService.length > 0) {
      params.service = listService.find((e) => e._id === params.service_id) || listService[0]
    }

    commit(types.ADD_DRAFT_ORDER, params)
  },
  cleanOrderFormPath({ commit }) {
    commit(types.CLEAN_ORDER_FORM_PATH)
  },
  getOrderFormEstimatedFeeRental({ dispatch, commit, rootGetters }, config = {}) {
    return new Promise((resolve, reject) => {
      const serviceId = state.service && state.service._id
      // console.log('xxx getOrderFormEstimatedFee', serviceId )

      if (!serviceId) {
        reject('no service')
      }

      let params = {
        order_type: constants.ORDER_TYPE.RENT,
        order_time: state.orderTime,
        idle_until: state.orderTime,
        path: state.path,
        service_id: state.service._id,
        requests: state.requests,
        number_of_drivers: state.number_of_drivers,
        hours_of_rental: state.hours_of_rental,
        payment_method: state.payment_method,
        promo_code: state.promoCode
      }

      // Add param to make estimate fee with suggested promotion
      if (config.autoRedeemPromoCode) {
        if (!state.promoCode) {
          params.suggest_promotion = true
        }
        dispatch('updateStatusAutoRedeemedPromoCode', true)
      }

      // Endprepare params for estimatedFeeV3 api

      commit(types.ESTIMATE_FEE_REQUEST)
      commit(types.UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES, true)

      estimateFeeV3Middleware({
        targetDataId: serviceId
      })(estimatedFeeRental(params))
        .then((data) => {
          if (data) {
            commit(types.ESTIMATE_FEE_SUCCESS, data)

            if (data.suggested_promotion) {
              dispatch('updateStatusAutoRedeemedPromoCode', data.suggested_promotion)
              dispatch('setOrderFormPromoCode', data.suggested_promotion)
            }

            resolve(data)
          } else {
            commit(types.ESTIMATE_FEE_FAILURE)
            reject('No response data')
          }
        })
        .catch((error) => {
          commit(types.ESTIMATE_FEE_FAILURE, error)
          reject(error)
        })
    })
  },
  setOrderFormNumberOfDrivers({ commit }, num) {
    commit(types.SET_ORDER_FORM_NUMBER_OF_DRIVERS, num)
  },
  setOrderFormHoursOfRental({ commit }, num) {
    commit(types.SET_ORDER_FORM_HOURS_OF_RENTAL, num)
  },
  setMethodPicked({ commit }, method) {
    commit(types.SET_METHOD_PICKED, method)
  },
  setInitLocation({ commit }, value) {
    commit(types.SET_INIT_LOCATION, value)
  },
  setInsuranceService({ commit }, value) {
    commit(types.SET_INSURANCE_SERVICE, value)
  },
  /* eslint-enable */

  ...nationwideOrderForm.default.actions,
  ...truckOrderForm.default.actions,
  ...rentalForm.default.actions,

  setActiveEntryPoint({ commit }, value) {
    commit(types.SET_ACTIVE_ENTRY_POINT, value)
  }
}

// mutations
const mutations = {
  [types.RESET_ORDER_FORM](state) {
    state.path = []
    state.setPathLogTime = null
    state.service = {}
    state.requests = []
    state.remarks = ''
    state.orderTime = 0
    state.images = []
    state.promoCode = ''
    state.setOrderTimeForPickup = false

    state.estimateFeeTimeout = null
    state.estimatedFee = {}
    state.estimatingFee = false
    state.estimateFeeError = null
    state.creatingOrder = false
    state.createOrderError = null

    state.promotionList = []
    state.insuranceService = {
      isEnable: true,
      insuranceValue: constants.INSURANCE_PACKAGE_TYPE.BASIC
    }
  },
  [types.RESET_ORDER_PATH](state) {
    state.path = state.path.length > 0 ? [state.path[0]] : []
  },
  [types.RESET_ORDER_FORM_ESTIMATE_FEE](state) {
    state.estimatingFee = false
    state.estimatedFee = {}
  },
  [types.INIT_ORDER_FORM_PATH](state, location) {
    state.path = [location]
    state.setPathLogTime = new Date().getTime()
  },
  [types.SET_ORDER_FORM_PATH](state, data) {
    state.path = data
    state.setPathLogTime = new Date().getTime()
  },
  [types.SET_ORDER_FORM_SERVICE](state, data) {
    state.service = data
    state.estimatedFee = {}
    if (!state.path.every((path) => !path.item_value || path.item_value === 0)) {
      const path = [...state.path]
      // path.forEach((item) => {
      //   item.item_value = 0
      // })
      state.path = path
    }
    if (data && data.estimated_fee) {
      // Note: auto set estimated fee if available
      if (data.estimated_fee.valid) {
        state.estimatedFee = data.estimated_fee
      } else if (data.estimated_fee.isError) {
        state.estimateFeeError = data.estimated_fee
      }
    }
    if (data.delivery_type !== 'TRUCK') {
      setCookie(COOKIE_NAME__SELECTED_SERVICE_ID, data._id, COOKIE_EXPIRES_MAX_AGE__3M)
    }
  },
  [types.ADD_ORDER_FORM_REQUESTS](state, requests) {
    if (requests) {
      requests.forEach((request) => {
        let index = state.requests.findIndex((r) => r._id === request._id)
        if (index === -1) {
          state.requests.push(request)
        } else {
          state.requests.splice(index, 1, request)
        }
      })
    }
  },
  [types.REMOVE_ORDER_FORM_REQUESTS](state, removeRequests) {
    if (removeRequests) {
      let _requests = []

      state.requests.forEach((request) => {
        const exist = removeRequests.find((r) => {
          return r._id === request._id
        })
        if (!exist) {
          _requests.push(request)
        }
      })

      state.requests = _requests
    }
  },
  [types.SET_ORDER_FORM_ESTIMATING_FEE](state, data) {
    if (data) {
      state.estimateFeeError = null
    }
    state.estimatingFee = data
  },
  [types.SET_ORDER_FORM_ESTIMATED_FEE](state, data) {
    state.estimatedFee = data
    state.estimateFeeError = null
    state.estimatingFee = false
  },
  [types.SET_ORDER_FORM_ESTIMATE_FEE_TIMEOUT](state, data) {
    if (!data) {
      if (state.estimateFeeTimeout) {
        clearTimeout(state.estimateFeeTimeout)
      }
    } else {
      state.estimateFeeTimeout = data
    }
  },
  [types.SET_ORDER_FORM_ESTIMATE_FEE_ERROR](state, data) {
    state.estimateFeeError = data
    state.estimatingFee = false
  },
  [types.SET_ORDER_FORM_CREATING_ORDER](state, data) {
    state.creatingOrder = data
  },
  [types.SET_ORDER_FORM_PROMO_CODE](state, code) {
    state.promoCode = code
  },
  [types.SET_ORDER_FORM_REMARKS](state, remarks) {
    state.remarks = remarks
  },
  [types.SET_ORDER_FORM_ORDER_TIME](state, data) {
    state.orderTime = parseInt(data.time) || 0

    if (data.setOrderTimeForPickup !== undefined) {
      state.setOrderTimeForPickup = data.setOrderTimeForPickup
    }
  },
  [types.SET_ORDER_FORM_IMAGES](state, images) {
    state.images = images
  },
  [types.SET_ORDER_FORM_ALL_INFO](state, newState) {
    Object.assign(state, newState)
  },
  [types.SET_ORDER_FORM_PAYMENT_METHOD](state, method) {
    state.payment_method = method
  },
  [types.SET_POD_PAYMENT_METHODS_LIST](state, data) {
    state.pod_payment_methods_list = data
  },
  [types.SET_ORDER_FORM_ESTIMATED_FEE_ALL_SERVICES](state, { data, error }) {
    if (data) {
      state.estimatedFeeAllServices = data
    } else {
      state.estimateFeeAllServicesError = error
    }
    state.estimatingFeeAllServices = false
  },
  [types.ESTIMATE_FEE_REQUEST](state) {
    state.estimatingFee = true
    state.estimatedFee = {}
    state.estimateFeeError = null
  },
  [types.ESTIMATE_FEE_SUCCESS](state, data) {
    state.estimatingFee = false
    state.estimatedFee = data
    // console.log("estimatedFee", state.estimatedFee)
  },
  [types.ESTIMATE_FEE_FAILURE](state, error) {
    state.estimatingFee = false
    if (error) {
      // console.log("ESTIMATE_FEE_FAILURE", error)
      state.estimateFeeError = error
    }
  },
  [types.CREATE_ORDER_REQUEST](state) {
    state.creatingOrder = true
  },
  [types.CREATE_ORDER_FAILURE](state) {
    state.creatingOrder = false
  },

  [types.SET_PROMOTION_LIST](state, data) {
    state.promotionList = data
  },
  [types.SET_FEATURED_BANNER](state, data) {
    state.featuredBanner = data
  },
  [types.UPDATE_SHOULD_ESTIMATE_FEE_ALL_SERVICES](state, value) {
    state.shouldEstimateFeeAllServices = value
  },
  [types.UPDATE_STATUS_SHOWED_ADD_BANK_MODAL](state, value) {
    state.isShowedAddBankModal = value
  },
  [types.UPDATE_STATUS_AUTO_REDEEMED_PROMO_CODE](state, value) {
    state.isAutoRedeemedPromoCode = value
  },
  [types.ADD_DRAFT_ORDER](state, data) {
    state.path = data.path
    state.service = data.service
    state.requests = data.requests
    state.remarks = data.remarks
    state.promoCode = data.promo_code
    state.payment_method = data.payment_method
    state.book_draft = true
  },
  [types.CLEAN_ORDER_FORM_PATH](state) {
    state.path = state.path.map((path) => {
      // delete path.item_value
      return path
    })
  },
  [types.SET_METHOD_PICKED](state, method) {
    state.method_picked = method
  },
  [types.SET_INIT_LOCATION](state, value) {
    state.initLocation = value
  },
  [types.SET_INSURANCE_SERVICE](state, value) {
    state.insuranceService = value
  },

  ...nationwideOrderForm.default.mutations,
  ...truckOrderForm.default.mutations,
  ...rentalForm.default.mutations,

  [types.SET_ACTIVE_ENTRY_POINT](state, value) {
    state.activeEntryPoint = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
